var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:[
    ("button--" + _vm.size),
    _vm.color,
    { 'is-bordered': _vm.bordered },
    { 'is-disabled': _vm.disabled },
    { 'button--full-width': _vm.fluid }
  ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }